import { storeToRefs } from 'pinia';
import { computed, type ComputedRef } from 'vue';

import type { DropdownMenuItem } from '@/shared/ui/dropdown';

import { IconMoon } from '@/shared/ui/icons';
import { UserTheme } from '@shared/api/graphql/gql/graphql';

import { useThemeStore } from './theme-store';

const THEME_OPTIONS: { theme: UserTheme; label: string }[] = [
  { theme: UserTheme.System, label: 'Как в системе' },
  { theme: UserTheme.Light, label: 'Светлая' },
  { theme: UserTheme.Dark, label: 'Тёмная' },
];

/** Пункт «Тема» меню пользователя с подменю вариантов. */
export function useThemeMenuItem(): ComputedRef<DropdownMenuItem> {
  const themeStore = useThemeStore();
  const { preference } = storeToRefs(themeStore);

  return computed(() => ({
    id: 'theme',
    label: 'Тема',
    icon: IconMoon,
    children: THEME_OPTIONS.map(({ theme, label }) => ({
      id: `theme-${theme}`,
      label,
      checked: preference.value === theme,
      onClick: () => themeStore.setPreference(theme),
    })),
  }));
}
